import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminGpsmap1243xsv = () => {
  // Get the product data directly from screensData
  const productId = "gpsmap-1243xsv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminGpsmap1243xsv - Direct Import - Product Data:', productData);
  console.log('GarminGpsmap1243xsv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-gpsmap-1243xsv.jpg";
  
  // Force EXACT matching only - no fuzzy matching
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-1243xsv"
      productName="Garmin GPSMAP 1243xsv"
      productImage={imageUrl}
      csvLookupId="GPSMAP 1243xsv"
      csvExactMatchOnly={true}
      componentType="screen"
    />
  );
};

export default GarminGpsmap1243xsv; 